import { gql } from "@apollo/client";

export const getAIMemoriesQuery = gql`
  query getAIMemories($entityType: String!) {
    ai {
      aiMemory(entityType: $entityType) {
        edges {
          node {
            id
            #entityType
            memory
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
